/**
 * Product Card Image Slider using Flickity
 */
class ProductCardImageSliderFlickity extends HTMLElement {
  constructor() {
    super();
    this.productCard = this.closest('.ProductItem__Wrapper');
  }

  connectedCallback() {
    // Wait for Flickity to be loaded
    if (typeof Flickity === 'undefined') {
      setTimeout(() => this.connectedCallback(), 100);
      return;
    }

    this.initFlickity();
  }

  initFlickity() {
    const carousel = this.querySelector('.slider__grid');

    if (!carousel) return;

    // Initialize Flickity
    this.flkty = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true, // This enables infinite loop
      prevNextButtons: false, // We'll use custom buttons
      pageDots: false,
      draggable: true,
      freeScroll: false,
      percentPosition: true,
      setGallerySize: false,
      adaptiveHeight: false,
      imagesLoaded: true,
      initialIndex: 1
    });

    // Setup custom navigation buttons
    this.setupNavigation();

    console.log('Flickity initialized for product:', this.flkty);
  }

  setupNavigation() {
    const prevBtn = this.querySelector('button[name="prev"]');
    const nextBtn = this.querySelector('button[name="next"]');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        this.flkty.previous();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        this.flkty.next();
      });
    }
  }

  disconnectedCallback() {
    // Cleanup when element is removed
    if (this.flkty) {
      this.flkty.destroy();
    }
  }
}

customElements.define('product-card-image-slider', ProductCardImageSliderFlickity);
